import { render, staticRenderFns } from "./InsightsContent.vue?vue&type=template&id=8856ed54&scoped=true"
import script from "./InsightsContent.vue?vue&type=script&lang=js"
export * from "./InsightsContent.vue?vue&type=script&lang=js"
import style0 from "./InsightsContent.vue?vue&type=style&index=0&id=8856ed54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8856ed54",
  null
  
)

export default component.exports